import React from 'react';
import { state } from '../state';
import { createBotTarget } from './createBotTarget';
import { toggleFeedbackWidget } from './toggleFeedbackWidget';

const botTarget = createBotTarget();
document.body.append(botTarget);

export function handleInteraction(
  e:
    | React.MouseEvent<HTMLButtonElement>
    | React.KeyboardEvent<HTMLButtonElement>,
) {
  if (state.clickTimeout) {
    clearTimeout(state.clickTimeout);
    state.clickTimeout = null;
  }

  const clickTarget = e.target as HTMLDivElement;
  toggleFeedbackWidget(state, botTarget, clickTarget);
  state.lastClickTarget = clickTarget;
}
